import React from 'react';
import { Button, ButtonElevation, ButtonType } from '@prisjakt/ui/button';
import { Behavior } from '@prisjakt/ui/text';
import { useOfferListFilterContext } from 'src/areas/product/components/offer-list-filter-context';
import { FilterType } from 'src/components/price-list/types';
import { VariantSelectionCallback } from '../types';
import { SelectionButtonText } from '../styles';

export const ColorVariantSelectionButton: React.FC<IVariantSelectionButton> = props => {
  const { variant, title, disabled, handleSelection } = props;
  const { getFilter } = useOfferListFilterContext();
  const filter = getFilter(FilterType.VARIANT_COLOR);
  const selection = filter?.active ? filter?.selection : null;
  const isSelected = Boolean(
    (variant && selection?.includes(variant)) || (!variant && !selection)
  );

  const onSelect = () => handleSelection(variant);

  return (
    <Button
      onClick={onSelect}
      selectable
      selected={isSelected}
      fullWidth
      type={ButtonType.OUTLINED}
      elevation={ButtonElevation.NONE}
      disabled={disabled}
    >
      <SelectionButtonText behavior={Behavior.OnelineEllipsis}>
        {title}
      </SelectionButtonText>
    </Button>
  );
};

interface IVariantSelectionButton {
  variant: string | null;
  title: string;
  handleSelection: VariantSelectionCallback;
  disabled?: boolean;
}
